<template>
  <div class="product-card" @click="openModal">
    <img :src="product.metadata.images[0].image.url" alt="Imagem do produto" class="image" />
    <h1 class="title">{{ product.title }}</h1>
    <p class="details">
      <b>Valor:</b> R$ {{ product.metadata.price }} <br />
      <b>Tamanho:</b> {{ product.metadata.size }} cm <br />
      <b>Tempo de produção:</b>
      {{
        product.metadata.production_time === ''
          ? '-'
          : product.metadata.production_time + ' dias' || '-'
      }}
      <br />
    </p>
    <p :class="`tag ${product.metadata.on_demand ? 'on_demand' : 'available'}`">
      {{ product.metadata.on_demand ? 'Sob Encomenda' : 'Pronta entrega' }}
    </p>
  </div>
</template>

<script>
import Modal from '@/components/Modal.vue';

export default {
  props: ['product'],
  methods: {
    openModal() {
      this.$buefy.modal.open({
        parent: this,
        component: Modal,
        hasModalCard: true,
        customClass: 'product-modal',
        trapFocus: true,
        props: { product: this.product },
      });
    },
  },
};
</script>

<style scoped>
.product-card {
  overflow: hidden;
  background-color: white;
  width: 300px;
  border-radius: 10px;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.22);
  font-family: 'Poppins', sans-serif;
  margin: 10px auto;
  cursor: pointer;
}

.image {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.title {
  font-size: 22px;
}

.details {
  font-size: 14px;
}

.title,
.details,
.tag {
  margin: 15px 15px 0;
}

.details,
.tag {
  margin-top: 10px;
}

.tag {
  margin-bottom: 15px;
  color: white;
  border-radius: 15px;
  padding: 0 15px;
}

.on_demand {
  background-color: #469abb;
}

.available {
  background-color: #48c55d;
}
</style>
